import type { APIComponentType } from '@ardoq/api-types';
import { DiffType } from '@ardoq/data-model';
import type { OldGraphItemDataModel } from './legacyTypes';

export class ComponentTypeValue implements OldGraphItemDataModel {
  componentType: APIComponentType;
  constructor(args: { componentType: APIComponentType }) {
    this.componentType = args.componentType;
  }

  isIncludedInContextByFilter(): boolean {
    return true;
  }

  name(): string {
    return this.componentType.name;
  }

  getCSS(): string {
    return '';
  }

  isReference(): boolean {
    return false;
  }

  get() {
    return undefined;
  }

  getVisualDiffType() {
    return DiffType.NONE;
  }
}
